import {
  LOGIN,
  LOGIN_WITH_TOKEN,
  REGISTER,
  LOGIN_PAGE_UNLOADED,
  ASYNC_START,
  ASYNC_END,
  LOGOUT,
  UPDATE_ACTIVE_FORM,
  LOGGED_IN,
  REFRESH_TOKEN,
} from '../constants/actionTypes';

const DEFAULT_AUTH_STATE = {
  inProgress: false,
  isAuthenticated: false,
  error: null, // if there any errors - it will be an array
  activeForm: 'login',
}
export default (state = DEFAULT_AUTH_STATE, action) => {
  switch (action.type) {
    case REFRESH_TOKEN:
    case LOGIN:
    case LOGIN_WITH_TOKEN:
    case REGISTER:
      return {
        ...state,
        isAuthenticated: (!action.error && action.type !== REGISTER) ? true : false,
        error: action.error ? action.payload : null,
      };
    case LOGGED_IN:
      return {
        ...state,
        isAuthenticated: true,
        error: null,
      }
    case LOGOUT:
      return {
        ...state,
        isAuthenticated: false
      }
    case LOGIN_PAGE_UNLOADED:
      return {
        ...DEFAULT_AUTH_STATE,
        isAuthenticated: state.isAuthenticated,
      };
    case UPDATE_ACTIVE_FORM:
      return {
        ...state,
        error: null,
        activeForm: action.activeForm,
      }
    case ASYNC_START:
      if (action.subtype === LOGIN || action.subtype === REGISTER) {
        return { ...state, inProgress: true };
      }
      break;
    case ASYNC_END:
      if (action.subtype === LOGIN || action.subtype === REGISTER) {
        return { ...state, inProgress: false };
      }
      break;
    default:
      return state;
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/auth.js